import { render, staticRenderFns } from "./CouponTemplateList.vue?vue&type=template&id=3652e7c6&scoped=true"
import script from "./CouponTemplateList.vue?vue&type=script&lang=js"
export * from "./CouponTemplateList.vue?vue&type=script&lang=js"
import style0 from "./CouponTemplateList.vue?vue&type=style&index=0&id=3652e7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652e7c6",
  null
  
)

export default component.exports